import styled from '@emotion/styled';

export const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: auto;
	margin-top: 0;
	width: 99%;

	> div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin: var(--margin-1);
		padding: var(--padding-2) var(--padding-1);
		gap: 1.5rem;
	}
`;
